import { MercatoSurveysList as MercatoSurveysListComponent } from "./MercatoSurveysList.component";
import { connector } from "./MercatoSurveysList.connector";

export const MercatoSurveysList = connector(MercatoSurveysListComponent);
